import React from 'react';
import PropTypes from 'prop-types';
import './YesNoInput.scss';
import TextAreaInput from '../TextAreaInput';
function MQInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    currentValue = _ref.currentValue,
    onInputChange = _ref.onInputChange,
    title = _ref.title,
    labelError = _ref.labelError;
  var isSelected = currentValue !== null && currentValue === value;
  var inputId = "".concat(id, "-").concat(value);
  return /*#__PURE__*/React.createElement("span", {
    className: "input-question body-text-2"
  }, /*#__PURE__*/React.createElement("input", {
    className: "yes-no-input",
    type: "radio",
    id: inputId,
    checked: isSelected,
    onChange: onInputChange,
    value: value
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: "body-text-2 normal-weight ".concat(labelError && 'with-error')
  }, title || value));
}
MQInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  currentValue: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  labelError: PropTypes.bool
};
MQInput.defaultProps = {
  currentValue: null,
  title: null,
  labelError: false
};
var isDescEmpty = function isDescEmpty(desc) {
  return !desc || !desc.trim();
};
function YesNoInput(props) {
  var id = props.id,
    className = props.className,
    onAnswerChange = props.onAnswerChange,
    value = props.value,
    showDescriptionInput = props.showDescriptionInput,
    onDescAnswerChange = props.onDescAnswerChange,
    descValue = props.descValue,
    errors = props.errors,
    reverseAnswer = props.reverseAnswer,
    exampleText = props.exampleText,
    textPromptClass = props.textPromptClass,
    textAreaPrompt = props.textAreaPrompt,
    yesNoQuestion = props.yesNoQuestion,
    labelError = props.labelError;
  var possibleAnswers = reverseAnswer ? ['No', 'Yes'] : ['Yes', 'No'];
  var placeholder = value === possibleAnswers[1] ? 'Tell us more... (required)' : 'Tell us more...';
  var error = null;

  // If user starts typing or chooses the non required value, remove the error from input
  if (showDescriptionInput && isDescEmpty(descValue) && value === possibleAnswers[1]) {
    error = errors["".concat(id, "_desc")];
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "yes-no-input-container ".concat(className)
  }, yesNoQuestion && /*#__PURE__*/React.createElement("span", {
    className: "pr-10"
  }, yesNoQuestion), /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, possibleAnswers.map(function (answer) {
    return /*#__PURE__*/React.createElement(MQInput, {
      id: id,
      key: answer,
      value: answer,
      currentValue: value,
      onInputChange: function onInputChange(e) {
        return onAnswerChange(e.target.value);
      },
      labelError: labelError
    });
  })), showDescriptionInput && value === possibleAnswers[1] && /*#__PURE__*/React.createElement("div", {
    className: "mt-15"
  }, error && error === 'field' && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mt-2 mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required!"), /*#__PURE__*/React.createElement(TextAreaInput, {
    placeholder: placeholder,
    value: descValue,
    error: error,
    onAnswerChange: onDescAnswerChange,
    exampleText: exampleText,
    textPromptClass: textPromptClass,
    textAreaPrompt: textAreaPrompt
  })));
}
YesNoInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOf(['Yes', 'No', null]),
  className: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  showDescriptionInput: PropTypes.bool,
  onDescAnswerChange: PropTypes.func,
  descValue: PropTypes.string,
  errors: PropTypes.shape({}),
  reverseAnswer: PropTypes.bool,
  exampleText: PropTypes.string,
  textPromptClass: PropTypes.string,
  textAreaPrompt: PropTypes.string,
  yesNoQuestion: PropTypes.string,
  labelError: PropTypes.bool
};
YesNoInput.defaultProps = {
  className: null,
  value: null,
  showDescriptionInput: false,
  onDescAnswerChange: null,
  // required if showDescriptionInput is true
  descValue: '',
  // required if showDescriptionInput is true
  errors: {},
  reverseAnswer: false,
  exampleText: null,
  textPromptClass: '',
  textAreaPrompt: 'Tell us more about that.',
  yesNoQuestion: null,
  labelError: false
};
export default YesNoInput;